export const userTypes = {
    1: 'Super Admin',
    2: 'Success Coach',
    3: 'POC',
    4: 'Speaker',
    5: 'Student',
    6: 'Implementation Team',
    7: 'Team of Three',
};
